import QuoteHeaderFull from './QuoteHeaderFull'
export default QuoteHeaderFull
export * from './QuoteHeaderFull'
